import { createFileRoute } from '@tanstack/react-router'

// /jobs/$jobId — job selected, no report open. This is the URL of the NAV STACK's middle level: the job's
// integrants list, with the report one push further in (see nav-stack.tsx, and the depth derivation in
// jobs.tsx). Making it a real route rather than a search-param flag is what lets the browser Back button pop
// the stack, keeps the level deep-linkable, and distinguishes "opened the job" from "asked for the job's own
// report" — two states that were the same URL before.
//
// It renders nothing into the report Outlet: on mobile that pane is off-stage, and on desktop it is the empty
// detail pane (the same shape `/offers/$offerId` has always had). The `jobs.$jobId` layout above provides the
// `jobId` param and owns the chrome + report prefetches, so this leaf needs no loader of its own.
export const Route = createFileRoute('/_app/jobs/$jobId/')({
  component: () => null,
})
